export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT as string;
export const API_URL = process.env.REACT_APP_API_URL as string;

export const DEFAULT_TITLE = 'CLB Chúng Ta Cùng Tiến';
export const TITLE = 'CTCT';
export const DEFAULT_DESCRIPTION =
  'Câu lạc bộ Chúng ta cùng tiến là Câu lạc bộ học thuật, được thành lập ngày 13 tháng 5 năm 2013. Câu lạc bộ được bảo trợ, quản lý bởi Phòng Công tác sinh viên - Trường Đại học Bách Khoa - ĐHQG-HCM.';
